// react
import React, { useMemo } from 'react';

// components
import {
  GenericFlowProps,
  OnboardingActions,
  toGenericOnboarding,
} from '@/components/pages/OnboardingFlow/OnboardingFlow';

export const OnboardingComponent = toGenericOnboarding(
  ({
    config,
    currentIndex = 0,
  }: GenericFlowProps<OnboardingComponentConfigItem>) => {
    const component = useMemo(() => {
      return config[currentIndex]?.component;
    }, [config, currentIndex]);
    return <>{component}</>;
  },
);

export interface OnboardingComponentConfigItem extends OnboardingActions {
  id: string;
  component: React.ReactNode;
}

OnboardingComponent.displayName = 'OnboardingComponent';
export default toGenericOnboarding(OnboardingComponent);
